<div class="px-6">
  @if (email) {
    @if (format === 'text') {
      <pre class="py-6 whitespace-pre-wrap break-words text-sm text-gray-900 font-mono">{{ contentPreviewText }}</pre>
      @if (shouldShowAttachmentPreview) {
        <div class="border-t border-gray-200 py-4 text-sm text-gray-900 font-mono">
          <p class="font-semibold">Attachments ({{ attachmentPreviewItems.length }})</p>
          @for (attachment of attachmentPreviewItems; track $index) {
            <p class="mt-1">- {{ attachment.filename }} — {{ attachment.source }}</p>
          } @empty {
            <p class="mt-1 text-gray-500">No attachments</p>
          }
        </div>
      }
    } @else {
      <div class="flex flex-row items-center justify-start py-6">
        <img [src]="tenantLogo" [alt]="tenantName" style="height: 80px; width: auto" />
      </div>
      <div class="pt-8 ck-content email-content text-left" [innerHtml]="contentPreviewHtml | safe: 'html'"></div>
      @if (shouldShowAttachmentPreview) {
        <div class="mx-3 mt-8 rounded-lg border border-gray-200 bg-gray-50 p-4">
          <p class="text-sm font-semibold text-gray-900">Attachments ({{ attachmentPreviewItems.length }})</p>
          <div class="mt-3 flex flex-col gap-2">
            @for (attachment of attachmentPreviewItems; track $index) {
              <div class="flex items-center justify-between gap-4 text-sm">
                <span class="text-gray-700">{{ attachment.filename }}</span>
                <span class="text-xs text-gray-500 shrink-0">{{ attachment.source }}</span>
              </div>
            } @empty {
              <p class="text-sm text-gray-500">No attachments</p>
            }
          </div>
        </div>
      }
      @if (tenantAvatar) {
        <div class="flex flex-row items-center justify-start py-6">
          <img [src]="tenantAvatar" [alt]="tenantName" style="height: 40px; width: auto" />
        </div>
      }
    }
  }
</div>
